import { type SelectProps } from "@mantine/core";
import { Select } from "src/components/shared/MantineCombobox";
import { useState } from "react";
import { useInputProps } from "src/generator/hooks/useInputProps";

interface ICabinSelect extends SelectProps {
  data: any[];
  value: any;
  id: string;
  required?: boolean;
}

const CabinSelect = ({ data, value, id, required, ...rest }: ICabinSelect) => {
  const getValue = () => {
    if (value?.key && value?.value) return value.value;
    else return value;
  };
  const {
    value: inputV,
    onChange,
    ...inputProps
  } = useInputProps(id, getValue(), required);

  const parsed = data.map(item => ({
    label: `${item.charAt(0).toUpperCase()}${item.slice(1)}`,
    value: item,
  }));
  const [selectedCabin, setSelectedCabin] = useState(inputV);
  const handleChange = (item: string) => {
    onChange(item);
    setSelectedCabin(item);
  };

  return (
    <Select
      data={parsed}
      onChange={handleChange}
      dropdownPosition="top"
      withinPortal={true}
      zIndex={1000}
      {...rest}
      {...inputProps}
      miw={200}
      value={selectedCabin}
    />
  );
};
export default CabinSelect;
